import type { CityGroup } from "@/shared/lib/amap/districtService";

/** 企业库找客户选中的地区(行政区划码 + 名字)。 */
export interface AreaPick {
  adcode: string;
  name: string;
}

/**
 * 省级行政区划码(GB/T 2260)。高德行政区服务不可用时(没配 VITE_AMAP_KEY)的退路:只能按省选。
 */
export const PROVINCES: readonly AreaPick[] = [
  { adcode: "110000", name: "北京市" },
  { adcode: "120000", name: "天津市" },
  { adcode: "130000", name: "河北省" },
  { adcode: "140000", name: "山西省" },
  { adcode: "150000", name: "内蒙古自治区" },
  { adcode: "210000", name: "辽宁省" },
  { adcode: "220000", name: "吉林省" },
  { adcode: "230000", name: "黑龙江省" },
  { adcode: "310000", name: "上海市" },
  { adcode: "320000", name: "江苏省" },
  { adcode: "330000", name: "浙江省" },
  { adcode: "340000", name: "安徽省" },
  { adcode: "350000", name: "福建省" },
  { adcode: "360000", name: "江西省" },
  { adcode: "370000", name: "山东省" },
  { adcode: "410000", name: "河南省" },
  { adcode: "420000", name: "湖北省" },
  { adcode: "430000", name: "湖南省" },
  { adcode: "440000", name: "广东省" },
  { adcode: "450000", name: "广西壮族自治区" },
  { adcode: "460000", name: "海南省" },
  { adcode: "500000", name: "重庆市" },
  { adcode: "510000", name: "四川省" },
  { adcode: "520000", name: "贵州省" },
  { adcode: "530000", name: "云南省" },
  { adcode: "540000", name: "西藏自治区" },
  { adcode: "610000", name: "陕西省" },
  { adcode: "620000", name: "甘肃省" },
  { adcode: "630000", name: "青海省" },
  { adcode: "640000", name: "宁夏回族自治区" },
  { adcode: "650000", name: "新疆维吾尔自治区" },
  { adcode: "710000", name: "台湾省" },
  { adcode: "810000", name: "香港特别行政区" },
  { adcode: "820000", name: "澳门特别行政区" },
];

/** 天眼查地区码 = "00" + 6 位行政区划码(样例 00110108 = 北京市海淀区)。 */
export function areaCodeOf(adcode: string): string {
  return `00${adcode}`;
}

/** 「浙江省杭州市」「杭州」「浙江」都要对得上:去掉行政后缀再比。 */
function core(name: string): string {
  return name
    .trim()
    .replace(/(特别行政区|维吾尔自治区|壮族自治区|回族自治区|自治区|自治州|地区|省|市|盟)$/u, "");
}

/**
 * 画像里的地区名 → 行政区。城市优先(更准),其次省;对不上返回 null(宁缺,不猜)。
 * 画像里常写成「浙江杭州」「杭州及周边」,所以按包含关系比,不要求逐字相等。
 */
export function matchRegion(name: string, groups: CityGroup[] | null): AreaPick | null {
  const n = name.replace(/\s/g, "");
  if (n.length < 2) return null;
  for (const g of groups ?? []) {
    for (const c of g.cities) {
      const k = core(c.name);
      if (k.length >= 2 && n.includes(k)) return { adcode: c.adcode, name: c.name };
    }
  }
  for (const p of PROVINCES) {
    const k = core(p.name);
    if (k.length >= 2 && n.includes(k)) return { adcode: p.adcode, name: p.name };
  }
  return null;
}
